import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { InspectionTypeEnum } from '@authority-labs/enums';
import { SelectInspectionDialogComponent } from './select-inspection-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SelectInspectionDialogService {
  private dialogConfig: MatDialogConfig;

  constructor(private dialog: MatDialog) {
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.minWidth = '65vw';
  }

  show(
    orderId: number,
    subProjectId: number,
    projectId: number,
    inspectionType: InspectionTypeEnum
  ): MatDialogRef<SelectInspectionDialogComponent, number> {
    this.dialogConfig.data = {
      orderId,
      subProjectId,
      projectId,
      inspectionType
    };
    return this.dialog.open<SelectInspectionDialogComponent, number>(
      SelectInspectionDialogComponent,
      this.dialogConfig
    );
  }
}
